module.exports = __webpack_public_path__ + "img/zidianmuluguanli.9e90d284.svg";